let omnicineRouteIntent = false;
const omnicineIntentListeners = new Set<(active: boolean) => void>();

function notifyOmniCineIntentListeners(): void {
  for (const listener of omnicineIntentListeners) {
    try {
      listener(omnicineRouteIntent);
    } catch {
      // ignore listener failures
    }
  }
}

export function hasOmniCineRouteIntent(): boolean {
  return omnicineRouteIntent;
}

export function markOmniCineRouteIntent(): void {
  if (omnicineRouteIntent) return;
  omnicineRouteIntent = true;
  notifyOmniCineIntentListeners();
}

export function subscribeOmniCineRouteIntent(
  listener: (active: boolean) => void,
): () => void {
  omnicineIntentListeners.add(listener);
  return () => {
    omnicineIntentListeners.delete(listener);
  };
}